import { motion } from "motion/react";
import { useTranslation } from "react-i18next";

export default function CTA() {
  const { t } = useTranslation();
  const waLink = String(t('cta.wa_link'));

  return (
    <section id="contact" className="py-24 px-6 scroll-mt-20">
      <motion.div 
        whileInView={{ y: [20, 0], opacity: [0, 1] }}
        className="max-w-5xl mx-auto bg-on-surface rounded-3xl p-10 md:p-20 text-center text-white relative overflow-hidden"
      >
        <div className="absolute top-0 right-0 w-64 h-64 bg-primary-container/20 rounded-full blur-[100px] -mr-32 -mt-32" />
        <h2 className="text-3xl md:text-5xl font-bold mb-8 relative z-10">{t('cta.title')}</h2>
        <p className="text-lg md:text-xl mb-12 opacity-80 relative z-10 max-w-2xl mx-auto">
          {t('cta.description')}
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4 relative z-10">
          <a 
            href={waLink} 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-primary-container text-white px-8 py-4 rounded-lg font-bold hover:bg-orange-600 transition-all hover:scale-105 inline-block"
          >
            {t('cta.btn_consult')}
          </a>
        </div>
      </motion.div>
    </section>
  );
}